import React from 'react';
import Modal from './Modal';
import PlayerAvatar from '../ui/PlayerAvatar';
import PositionBadge from '../ui/PositionBadge';

const VoteDetailModal = ({ isOpen, onClose, player, distribution, outlierVotes, filteredAvg, totalVotes, noData }) => {
  if (!isOpen) return null;

  const sortedEntries = Object.entries(distribution || {})
    .map(([score, count]) => ({ score: Number(score), count }))
    .sort((a, b) => b.score - a.score);

  const outlierCounts = {};
  (outlierVotes || []).forEach(v => {
    const key = v;
    outlierCounts[key] = (outlierCounts[key] || 0) + 1;
  });
  const sortedOutliers = Object.entries(outlierCounts)
    .map(([score, count]) => ({ score: Number(score), count }))
    .sort((a, b) => b.score - a.score);

  const maxCount = Math.max(...sortedEntries.map(e => e.count), 1);

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="flex flex-col items-center gap-1 mb-4">
        <PlayerAvatar user={player} size="lg" />
        <p className="font-bold text-slate-800 text-base mt-1">{player?.name || 'Jogador'}</p>
        {player?.position && <PositionBadge position={player.position} />}
      </div>

      {noData ? (
        <div className="text-center py-6 text-slate-400">
          <p className="text-sm">Dados de votos não disponíveis.</p>
          <p className="text-xs mt-1">Este jogo pode ter sido finalizado sem votação ou o grupo não está mais acessível.</p>
        </div>
      ) : (
        <>
          <div className="flex justify-between items-center mb-3">
            <p className="text-[11px] font-semibold tracking-widest text-slate-400 uppercase">Notas recebidas</p>
            <span className="text-sm font-bold text-slate-600">{totalVotes}</span>
          </div>

          <div className="flex flex-col gap-2 mb-4">
            {sortedEntries.map(({ score, count }) => (
              <div key={score} className="flex items-center gap-3">
                <span className="w-5 text-right font-bold text-slate-700 text-sm">{score}</span>
                <div className="flex-1 bg-slate-100 rounded-full h-2.5 overflow-hidden">
                  <div
                    className="h-full bg-emerald-500 rounded-full"
                    style={{ width: `${(count / maxCount) * 100}%` }}
                  />
                </div>
                <span className="text-xs text-slate-500 w-14 text-right">
                  {count} {count === 1 ? 'voto' : 'votos'}
                </span>
              </div>
            ))}
          </div>

          {sortedOutliers.length > 0 && (
            <div className="mb-4">
              <p className="text-[10px] font-semibold tracking-widest text-slate-400 uppercase mb-2">
                Não contabilizadas
              </p>
              <div className="flex flex-col gap-2">
                {sortedOutliers.map(({ score, count }) => (
                  <div key={score} className="flex items-center gap-3 opacity-40">
                    <span className="w-5 text-right font-bold text-slate-500 text-sm line-through">{score}</span>
                    <div className="flex-1 bg-slate-100 rounded-full h-2.5">
                      <div className="h-full bg-slate-400 rounded-full w-full" style={{ width: `${(count / maxCount) * 100}%` }} />
                    </div>
                    <span className="text-xs text-slate-400 w-14 text-right">
                      {count} {count === 1 ? 'voto' : 'votos'}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          )}

          <div className="flex items-center justify-between pt-3 border-t border-slate-100">
            <span className="text-xs text-slate-400">Média válida</span>
            <span className="font-bold text-emerald-600 text-lg">{filteredAvg?.toFixed(1)}</span>
          </div>

          <p className="text-[10px] text-slate-400 leading-relaxed mt-3">
            O Pelada Pro usa um algoritmo que descarta notas muito fora da média para garantir uma avaliação justa.
            Notas com grande desvio em relação ao grupo não entram na média.
            Quem votar de forma recorrentemente tendenciosa terá suas notas desconsideradas automaticamente.
          </p>
        </>
      )}
    </Modal>
  );
};

export default VoteDetailModal;
